import { Preferences } from "@capacitor/preferences";

/**
 * Gets a value from preferences storage.
 *
 * @param key - The key to retrieve
 * @returns The stored value, or null if not found
 */
export async function getPreference(key: string): Promise<string | null> {
  const { value } = await Preferences.get({ key });
  return value;
}

/**
 * Sets a value in preferences storage.
 *
 * @param key - The key to set
 * @param value - The value to store
 */
export async function setPreference(key: string, value: string): Promise<void> {
  await Preferences.set({ key, value });
}

/**
 * Clears all preferences storage.
 */
export async function clearPreferences(): Promise<void> {
  await Preferences.clear();
}
